<!-- <button class="dashed-box w-100 mx-0"
        (click)="toggleShowDialog()"
        [disabled]="disabled() || organization()">
    @if (!readonly && organization()) {
    <button kendoButton
            [icon]="'close'"
            [fillMode]="'clear'"
            [size]="'small'"
            (click)="onDeleteOrganization()">
    </button>
    }
    @if (!readonly && !organization()) {
    <div class="centered">
        <pmis3-vessel-visit-detail-organization-picker [disabled]="disabled()"
                                                       (assignedOrganization)="onOrganizationFromChild($event)"
                                                       [showDialog]="showDialog">
        </pmis3-vessel-visit-detail-organization-picker>
    </div>
    }
    @else {
    <div class="spaced-between">
        <div>
            <b>{{ organization()?.organizationType?.organizationTypeName }}</b>
        </div>
        <kendo-icon name="home"
                    style="font-size: 20px"></kendo-icon>
        <div style="font-size: 10px">
            Name: <b>{{ organization()?.organization?.name }}</b>
        </div>
    </div>
    }
</button> -->

<div class="w-100 cursor-pointer border border-dashed border-gray-light border-radius-8 position-relative"
     style="height:90px; min-width: 190px;"
     [ngClass]="{'k-disabled':disabled()}"
     (click)="toggleShowDialog()">
    @if (!readonly() && organization()) {
        <div class="position-absolute position-right-0">
            <button kendoButton
                    [icon]="'close'"
                    [fillMode]="'clear'"
                    [size]="'small'"
                    (click)="onDeleteOrganization()">
            </button>
        </div>
    }
    @if (!readonly() && !organization()) {
        <div class="centered" [ngClass]="{'k-disabled':disabled() || organization()}">
            <pmis3-vessel-visit-detail-organization-picker [disabled]="disabled()"
                                                        (assignedOrganization)="onOrganizationFromChild($event)"
                                                        [showDialog]="showDialog">
            </pmis3-vessel-visit-detail-organization-picker>
        </div>
    } @else {
        <div class="d-flex flex-column align-items-center justify-content-center h-100 w-100"
            [ngClass]="{'k-disabled':disabled(), 'text-grey':disabled()}">
            <h5 class="m-0" >
                <b>{{ organizationTypeName() }}</b>
            </h5>
            <kendo-icon name="home"
                        [size]="'large'"></kendo-icon>
            <div>
                Name: <b>{{ organizationName() }}</b>
            </div>
        </div>
    }
</div>